import React, { useMemo } from "react";
import { Tabs, Tab } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import WorkspacePage from "../../../components/WorkspacePage";
import UsageHistory from "./UsageHistory";
import ShipmentHistory from "./ShipmentHistory";
import CheckInTab from "./CheckInTab";
import AliquotsListTab from "./AliquotsListTab";

const TAB_VALUES = ["check-in", "check-out", "checkout-history", "usage-history"];
const LEGACY_TAB_STORAGE_KEY = "sampleCheckInOutTab";

const getInitialTab = (searchParams) => {
  const queryTab = searchParams.get("tab");
  if (TAB_VALUES.includes(queryTab)) {
    return TAB_VALUES.indexOf(queryTab);
  }

  const saved = sessionStorage.getItem(LEGACY_TAB_STORAGE_KEY);
  const savedIndex = saved !== null ? parseInt(saved, 10) : 0;
  return Number.isInteger(savedIndex) && TAB_VALUES[savedIndex] ? savedIndex : 0;
};

const AliquotManagement = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = useMemo(() => getInitialTab(searchParams), [searchParams]);

  const handleTabChange = (event, value) => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set("tab", TAB_VALUES[value]);
    sessionStorage.setItem(LEGACY_TAB_STORAGE_KEY, value);
    setSearchParams(nextParams, { replace: true });
  };

  return (
    <WorkspacePage>
      <PageHeader
        title="Aliquot Management"
        tabs={
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tab label="Check-In" data-tour-id="tour-aliquot-tab-checkin" />
            <Tab label="Check-Out" data-tour-id="tour-aliquot-tab-checkout" />
            <Tab label="Check-out history" data-tour-id="tour-aliquot-tab-history" />
            <Tab label="Usage history" data-tour-id="tour-aliquot-tab-usage" />
          </Tabs>
        }
      />

      {activeTab === 0 && <CheckInTab />}
      {activeTab === 1 && <AliquotsListTab key="checkout" mode="checkout" />}
      {activeTab === 2 && <ShipmentHistory />}
      {activeTab === 3 && <UsageHistory />}
    </WorkspacePage>
  );
};

export default AliquotManagement;
